module.exports = __webpack_public_path__ + "static/media/contentsc.435a08f5.png";